import { langRouteI18n } from '../i18n/lang-route-i18n';
import { maintenanceRouteI18n } from '../i18n/maintenance-route-i18n';

export function maintenanceRoutePath(): string {
  return `/${langRouteI18n()}/${maintenanceRouteI18n()}`;
}
